import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss']
})
export class ConfirmComponent implements OnInit {

  text: string|null = null;
  acceptText: string|null = null;
  declineText: string|null = null;

  constructor(
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig
  ) {
    this.config.width = '400px';
    this.config.header = this.config.data.title;
    this.text = this.config.data.text || null;
    this.acceptText = this.config.data.acceptText || null;
    this.declineText = this.config.data.declineText || null;
  }

  ngOnInit(): void {
  }

  close(result: boolean = false): void {
    this.ref.close(result);
  }

}
